var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortDateDescending(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sort_date_descending_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sort_date_descending_svg__dt{fill:url(#sort_date_descending_svg__ds)}.sort_date_descending_svg__du{fill:#f7f7f7}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sort_date_descending_svg__ds",
    x1: 292.4,
    y1: 285.09,
    x2: 354.65,
    y2: 285.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sort_date_descending_svg__du",
    d: "m106.47,175.98h0c-17.16,0-31.12,13.96-31.12,31.12s13.96,31.12,31.12,31.12h0c17.16,0,31.12-13.96,31.12-31.12s-13.96-31.12-31.12-31.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "sort_date_descending_svg__du",
    d: "m178.83,175.98h0c-17.16,0-31.12,13.96-31.12,31.12s13.96,31.12,31.12,31.12h0c17.16,0,31.12-13.96,31.12-31.12s-13.96-31.12-31.12-31.12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "sort_date_descending_svg__du",
    d: "m251.18,175.98h0c-17.16,0-31.12,13.96-31.12,31.12s13.96,31.12,31.12,31.12h0c17.16,0,31.12-13.96,31.12-31.12s-13.96-31.12-31.12-31.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "sort_date_descending_svg__du",
    d: "m323.53,175.98h0c-17.16,0-31.12,13.96-31.12,31.12s13.96,31.12,31.12,31.12h0c17.16,0,31.12-13.96,31.12-31.12s-13.96-31.12-31.12-31.12Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "sort_date_descending_svg__du",
    cx: 106.47,
    cy: 285.09,
    r: 31.12
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "sort_date_descending_svg__du",
    d: "m178.83,253.97h0c-17.16,0-31.12,13.96-31.12,31.12s13.96,31.12,31.12,31.12h0c17.16,0,31.12-13.96,31.12-31.12s-13.96-31.12-31.12-31.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "sort_date_descending_svg__du",
    d: "m251.18,253.97h0c-17.16,0-31.12,13.96-31.12,31.12s13.96,31.12,31.12,31.12h0c17.16,0,31.12-13.96,31.12-31.12s-13.96-31.12-31.12-31.12Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "sort_date_descending_svg__du",
    d: "m387.09,110.91c-.7-13.8-12.15-24.81-26.12-24.81h-21.76v-4.54c0-6.63-5.37-12-12-12h0c-6.63,0-12,5.37-12,12v4.54h-88.21v-4.54c0-6.63-5.37-12-12-12h0c-6.63,0-12,5.37-12,12v4.54h-88.21v-4.54c0-6.63-5.37-12-12-12h0c-6.63,0-12,5.37-12,12v4.54h-21.76c-13.97,0-25.41,11.01-26.12,24.81-.02.45-.03.89-.03,1.34v222.02c0,14.42,11.74,26.16,26.16,26.16h291.92c14.42,0,26.16-11.74,26.16-26.16V112.25c0-.45-.01-.9-.03-1.34Zm-296.29-.81v4.97c0,6.63,5.37,12,12,12h0c6.63,0,12-5.37,12-12v-4.97h88.21v4.97c0,6.63,5.37,12,12,12h0c6.63,0,12-5.37,12-12v-4.97h88.21v4.97c0,6.63,5.37,12,12,12h0c6.63,0,12-5.37,12-12v-4.97h21.75c1.19,0,2.16.96,2.16,2.15v19.51H66.88v-19.51c0-1.19.97-2.15,2.16-2.15h21.75Zm272.33,224.17c0,1.19-.97,2.16-2.16,2.16H69.04c-1.19,0-2.16-.97-2.16-2.16v-178.51h296.24v178.51Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "sort_date_descending_svg__dt",
    cx: 323.53,
    cy: 285.09,
    r: 31.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDateDescending);
export default __webpack_public_path__ + "static/media/sort_date_descending.cfd5cbc21c15bfb1e9febb26b0252339.svg";
export { ForwardRef as ReactComponent };